<template>
  <header class="app-header">
    <div class="header-inner">
      <div class="brand" @click="$router.push('/')">
        <img class="brand-logo" :src="logoSrc" alt="logo" />
        <span class="brand-name">仑享厂房</span>
      </div>
      <nav class="nav">
        <RouterLink class="nav-link" to="/">出租房源</RouterLink>
        <RouterLink class="nav-link" to="/rental-demand">求租房源</RouterLink>
        <span class="nav-link" @click="handlePushClick">发布房源</span>
        <RouterLink class="nav-link" to="/recommend">智能推荐</RouterLink>
      </nav>
      <div class="actions">
        <span class="action-link" @click="handleUserClick">个人中心</span>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { getToken } from '@/utils/auth'

const router = useRouter()
const logoSrc = computed(() => require('@/assets/logo2.png'))

const checkLoginAndNavigate = (path: string) => {
  const token = getToken()
  if (!token) {
    Modal.confirm({
      title: '提示',
      content: '您还未登录，是否前往登录？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        window.location.href = 'https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330206283372202210017392&userType=person&sp=https://lxsh.bl.cn/lxcf-pc?from=zqykt'
      }
    })
  } else {
    router.push(path)
  }
}

const handlePushClick = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
  checkLoginAndNavigate('/push')
}

const handleUserClick = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
  checkLoginAndNavigate('/user')
}
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;
}
.brand { 
  display: flex; 
  align-items: center; 
  cursor: pointer; 
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  outline: none;
}
.brand-logo { width: 28px; height: 28px; margin-right: 8px; }
.brand-name { 
  font-size: 18px; 
  font-weight: 600; 
  color:#1a56db;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.nav { display: flex; align-items: center; gap: 24px; }
.nav-link { 
  color: #334155; 
  text-decoration: none; 
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  outline: none;
}
.nav-link:hover { color: #1a56db; }

.actions { display: flex; align-items: center; gap: 16px; }
.action-link { 
  color:#1a56db; 
  text-decoration: none; 
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  outline: none;
}
.action-link:hover { text-decoration: underline; }

@media (max-width: 768px) {
  .header-inner { max-width: 100%; }
  .nav { gap: 12px; }
}
</style>


